var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 50,
  height: 50
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#7F2A90",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "m25.652 3.132 4.98 14.837a.85.85 0 0 0 .802.579l15.429.001c.81 0 1.157 1.026.514 1.519l-12.388 9.486a.85.85 0 0 0-.291.926l4.564 14.539c.24.77-.625 1.408-1.289.952l-12.644-8.702a.85.85 0 0 0-.96 0l-12.644 8.702c-.665.456-1.53-.183-1.288-.952l4.565-14.539a.85.85 0 0 0-.292-.926L2.321 20.067c-.643-.492-.295-1.519.515-1.519l15.428-.001a.85.85 0 0 0 .803-.579l4.98-14.837c.258-.769 1.347-.769 1.605.001"
})));
export default SvgStar;